export const NAME = 'unlockedClients';

export const quickFilter = {
	MOBILE_APPLICATION: 'MOBILE_APPLICATION',
	SMS: 'SMS',
	WEBCAM: 'WEBCAM',
	PLANNED_ACTIVITY: 'PLANNED_ACTIVITY',
	BANK_ID: 'BANK_ID',
	E_DOKLADY: 'E_DOKLADY',
};

export const UNLOCK_METHODS = {
	webcam: '1',
	mobileApplication: '2',
	sms: '3',
	plannedActivity: '6',
	bankId: '9',
	eDoklady: '10',
};

export const quickFilterTypesSetup = [
	{
		label: 'unlockedClients:mobileApplication',
		type: quickFilter.MOBILE_APPLICATION,
	},
	{
		label: 'unlockedClients:sms',
		type: quickFilter.SMS,
	},
	{
		label: 'unlockedClients:webcam',
		type: quickFilter.WEBCAM,
	},
	{
		label: 'unlockedClients:plannedActivity',
		type: quickFilter.PLANNED_ACTIVITY,
	},
	{
		label: 'unlockedClients:bankId',
		type: quickFilter.BANK_ID,
	},
	{
		label: 'unlockedClients:eDoklady',
		type: quickFilter.E_DOKLADY,
	},
];

export const formDataFieldsMap = {
	surname: 'Příjmení',
	firstName: 'Jméno',
	businessName: 'Název',
	personIn: 'Rodné číslo',
	businessIn: 'IČO',
	birthDate: 'Datum narození',
	unlockedFrom: 'Datum odemčení od',
	unlockedTo: 'Datum odemčení do',
	extendedFrom: 'Prodlouženo od',
	extendedTo: 'Prodlouženo do',
	unlockChannels: 'Způsob odemčení',
	quickFilterMobileApp: 'Mobilní aplikace',
	quickFilterPlannedActivity: 'Plánovaná aktivita',
	quickFilterSms: 'SMS',
	quickFilterWebcam: 'Webkamera',
	bankId: 'BankID',
};
